/**
 * Vuex actions for the customercare module.
 *
 * @module store/modules/customercare/actions
 */
import _ from "lodash";

import { rest } from "@/store/api";
import { RootState } from "@/store/types";
import { ActionTree } from "vuex/types";
import { CustomerCareState } from "./types";

const actions: ActionTree<CustomerCareState, RootState> = {
  /**
   * Fetches Metabase dashboards from specific collection.
   *
   * @param {ActionContext} context - Vuex action context
   * @returns {Promise<Array>} Sorted list of dashboards from collection
   *
   * @example
   * await this.$store.dispatch('CUSTOMER_CARE_GET_DASHBOARDS');
   */
  CUSTOMER_CARE_GET_DASHBOARDS: async ({ state, commit, dispatch }) => {
    const result = await rest("get", "get_metabase_dashboards_by_collection");
    commit("CUSTOMER_CARE_SET_DASHBOARDS", _.sortBy(result, ["id"]));
    return result;
  },

  /**
   * Sets the currently selected tab.
   *
   * @param {ActionContext} context - Vuex action context
   * @param {string} payload - Tab identifier
   * @returns {Promise<void>}
   */
  CUSTOMER_CARE_SET_SELECTED_TAB: async ({ state, commit, dispatch }, payload) => {
    commit("CUSTOMER_CARE_SET_SELECTED_TAB", payload);
  },

  /**
   * Sets the editor visibility state.
   *
   * @param {ActionContext} context - Vuex action context
   * @param {boolean} payload - Visibility flag
   * @returns {Promise<void>}
   */
  CUSTOMER_CARE_SET_EDITOR_VISIBLE: async ({ state, commit, dispatch }, payload) => {
    commit("CUSTOMER_CARE_SET_EDITOR_VISIBLE", payload);
  },

  /**
   * Toggles the editor visibility state.
   *
   * @param {ActionContext} context - Vuex action context
   * @returns {Promise<void>}
   */
  CUSTOMER_CARE_TOGGLE_EDITOR_VISIBLE: async ({ state, commit, dispatch }) => {
    commit("CUSTOMER_CARE_TOGGLE_EDITOR_VISIBLE");
  },
};

export default actions;
